import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

import 'swiper/css';
import { domContentLoadEvent } from '../common/domContentLoadEvent';

function initPillars(element) {
    const swiper = new Swiper(element.querySelector('.swiper-pillars'), {
        modules: [Navigation],
        slidesPerView: 'auto',
        spaceBetween: 24,
        breakpoints: {
            768: {
                slidesPerView: 0,
                spaceBetween: 0,
            },
        },
        navigation: {
            nextEl: element.querySelector('.swiper-button-next'),
            prevEl: element.querySelector('.swiper-button-prev'),
        },
    });
}

function initAllPillars() {
    document.querySelectorAll('.pillars').forEach(function (element) {
        initPillars(element);
    });
}

domContentLoadEvent(initAllPillars);
